import axios from "axios";
import { Base_URL } from "../url";

const API_URL = "http://192.168.29.242:5090/api/ExpensesDetails/GetDataUserId"; // Update with your API endpoint

export const fetchExpenses = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/ExpensesDetails/GetData/id?id=${id}`);
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching expenses!";
  }
};

export const fetchExpensesByUserId = async (userId) => {
  try {
    const response = await axios.get(`${Base_URL}/ExpensesDetails/GetDataUserId?UserId=${userId}`);
    console.log("Expenses for user:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching expenses by user ID:", error);
    throw error.response?.data || "Error fetching user expenses!";
  }
};
